// extracted by mini-css-extract-plugin
export default {"button":"Button_button__sBx4u","primary":"Button_primary__1E8ax","secondary":"Button_secondary__vZOAZ"};